export default "__VITE_ASSET__DOLL6odg__"